jQuery(function ($) {
  /**
   * Image Gallery (Swiper)
   */
  {
    const initSwiper = (selector) => {
      const thumbs = new Swiper(`${selector} .thumbnails.swiper`, {
        direction: 'horizontal',
        freeMode: true,
        watchSlidesProgress: true,
        slidesPerView: 6,
        spaceBetween: 6,
      });
      new Swiper(`${selector} .gallery.swiper`, {
        direction: 'horizontal',
        slidesPerView: 1,
        grabCursor: true,
        autoHeight: true,
        zoom: true,
        ...(thumbs.$el != null && {
          thumbs: {
            swiper: thumbs,
          },
        }),
      });
    };

    // if ".default-gallery" exists, it means it is a simple product.
    // Variable products are fetched dynamically
    if ($('.default-gallery').length > 0) {
      initSwiper('.default-gallery');
    }

    $(document).on('found_variation', (e, variation) => {
      $('.gallery-wrapper').hide();
      if (variation['gallery'] == null) {
        $('.default-gallery').show();
        return;
      }

      const selector = `.gallery-wrapper[data-variation_id="${variation.variation_id}"]`;
      const variationGallery = $(selector);

      if (variationGallery.length === 0) {
        $('.galleries-wrapper').append(variation['gallery']);
        initSwiper(selector);
        return;
      }
      variationGallery.show();
    });
  }

  const $loader = $('.bb-loader-wrapper');

  // stop propagation of pswp close button (gallery lightbox)
  $('.pswp__button--close').on('pswpTap', function (e) {
    e.stopPropagation();
  });

  /**
   * Sometimes the default variation might change and never trigger the "found_variation" event.
   * When this happens, the loader animation never stops and it appears as if the product never loads.
   * So, when the value of the select is empty, we find an option that also contains the class "enabled".
   * And then we change the value of the select, which triggers the found variation event.
   *
   * NOTE: the enabled class is set by WC programatically with JS, so we wait 200ms so the option
   * has that class already.
   */
  const select = $('select#pa_format');
  if (select.length !== 0) {
    setTimeout(() => {
      const selectVal = select.val();
      if (typeof selectVal === 'undefined' || selectVal === '') {
        const validOptions = $('select#pa_format > option.enabled');
        if (validOptions.length === 0) {
          throw new Error(
            `No valid options for product with name: "${$(
              '.product-summary .header .title'
            ).text()}"`
          );
        }
        $('select#pa_format').val(validOptions.first().val()).change();
      }
    }, 300);
  }

  /**
   * Found Variation.
   */
  $(document).on('found_variation', (e, variation) => {
    /**
     * PX Key Value Extras.
     */
    {
      const { bb_px_kv_extras } = variation;
      if (bb_px_kv_extras != null) {
        const $extendedInformation = $('#extended_information');
        const $productInformation = $('#product_information');

        // extended_information (Erweiterte Angaben)
        if (
          typeof bb_px_kv_extras.extended_information !== 'undefined' &&
          bb_px_kv_extras.extended_information != null
        ) {
          $extendedInformation.html(bb_px_kv_extras.extended_information);
          $extendedInformation.parent().show();
        } else {
          $extendedInformation.parent().hide();
        }

        // product_information (Produktinformationen)
        if (
          typeof bb_px_kv_extras.product_information !== 'undefined' &&
          bb_px_kv_extras.product_information != null
        ) {
          $productInformation.html(bb_px_kv_extras.product_information);
          $productInformation.parent().show();
        } else {
          $productInformation.parent().hide();
        }
      }
    }

    /**
     * Price on Request.
     */
    {
      const isPriceOnRequest =
        $('.product-summary .price-on-request').length > 0;
      if (isPriceOnRequest) {
        $('.price-rules-table').remove();
        $('.quantity-wrapper').hide();
        $('.product-cta-wrapper.variation').hide();
        $loader.fadeOut(100);
      } else {
        $('.quantity-wrapper').show();
        $('.product-cta-wrapper.variation').show();
      }
    }

    // Storage is rendered by the variation template (see "variation.php").
    $loader.fadeOut(100);
  });
});
